import React, { useCallback, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';

import Dropzone from 'core/components/Dropzone';
import UploadProgressIndicator, { UploadProgressState } from 'core/components/UploadProgressIndicator';

const useStyles = makeStyles((theme) => ({
  dropzone: {
    position: 'absolute',
    top: theme.spacing(1),
    left: -theme.spacing(1),
    width: `calc(100% + ${theme.spacing(2)})`,
    height: 'calc(100vh - 280px)',
  },
  uploadIndicator: {
    marginTop: theme.spacing(2),
  },
}));

const FileUploader = forwardRef((props, ref) => {
  const classes = useStyles();
  const { onFileSelected, fileName, progress, error, state, accept, onClose } = props;

  const onDocumentInputChange = useCallback(() => {
    const { files } = ref.current;
    const [file] = files;
    if (!file) return;
    onFileSelected(file);
  }, [ref, onFileSelected]);

  return (
    <>
      <Dropzone className={classes.dropzone} message={<FormattedMessage id="dndUploadDocument" />} onDropFile={onFileSelected} accept={accept} />
      <UploadProgressIndicator
        className={classes.uploadIndicator}
        progress={progress}
        fileName={fileName}
        state={state}
        error={error}
        onClose={onClose}
      />
      <input type="file" id="file" ref={ref} style={{ display: 'none' }} onChange={onDocumentInputChange} />
    </>
  );
});

FileUploader.propTypes = {
  onFileSelected: PropTypes.func,
  onClose: PropTypes.func,

  fileName: PropTypes.string,
  progress: PropTypes.number,
  error: PropTypes.string,

  accept: PropTypes.string,

  state: PropTypes.oneOf([
    UploadProgressState.idle,
    UploadProgressState.processing,
    UploadProgressState.uploading,
    UploadProgressState.saving,
    UploadProgressState.success,
    UploadProgressState.failed,
  ]),
};

FileUploader.defaultProps = {
  onFileSelected() {},
  onClose() {},

  progress: undefined,
  fileName: '',
  error: undefined,
  state: UploadProgressState.idle,
  accept: undefined,
};

export default FileUploader;
